import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnablementPricingResponse } from '../models/enablement/enablement-pricing-response.model';
import { LocaleService } from './locale.service';

const apiUrl = `${environment.flyLegacyUrl}/api/`;
const enablementPricingUrl = `${apiUrl}enablement-pricing/`;

@Injectable()
export class EnablementPricingService {
  constructor(
    private readonly http: HttpClient,
    private readonly localeService: LocaleService
  ) {}

  getEnablementPricingForDevices(deviceIDs: number[]): Observable<EnablementPricingResponse[]> {
    const params: Record<string, any> = {};
    params.deviceIDs = deviceIDs;
    return this.pricingRequest(params);
  }

  private pricingRequest(params: Record<string, any>): Observable<EnablementPricingResponse[]> {
    return this.localeService.getSelectedLocale().pipe(
      mergeMap((locale) => {
        return this.http.get<EnablementPricingResponse[]>(`${enablementPricingUrl}${locale.wpcLocale}/`, { params });
      })
    );
  }
}
